export enum DBCollectionNames {
  MEDITATION_VOICES= "meditation_voices",
  USERS = "users",
  CORPORATE_DASH_PERMISSIONS_GROUP = "corporate_dashboard_permission_group"
}
